import { useTranslate } from '@va/localization';
import { CustomDomainPlatformType, CustomDomainsApi, CustomDomainTarget } from '@va/shared/api/custom-domains';
import { DNSVerificationStatusMap } from '@va/shared/custom-domains';
import { ConfirmationDialogProps } from '@va/shared/util-confirmation';
import { ModalHeader, Paragraph } from '@va/ui/design-system';
import { ModalWrapper } from '@va/util/components';
import { useState } from 'react';
import { VerifyDnsSection } from './VerifyDnsSection';

export const ViewDNSRecordsModal: React.FC<
  ConfirmationDialogProps & {
    domain: string;
    expectedDNSRecordsCount: number;
    title: string;
    target: CustomDomainTarget;
    isOpen: boolean;

    platform: CustomDomainPlatformType;
    onFailure: (err: string) => void;
  }
> = ({ onClose, domain, expectedDNSRecordsCount, title, target, platform, isOpen, onFailure }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [dnsVerificationStatusMap, setDnsVerificationStatusMap] = useState<DNSVerificationStatusMap>({});

  const dnsRecordsReq = CustomDomainsApi.useGetTargetedDNSRecords(
    !domain
      ? null
      : {
          platform: platform,
          domain: domain,
          target: target,
        },
  );

  const translate = useTranslate();

  return (
    <ModalWrapper closeModal={onClose} isModalOpen={isOpen}>
      <ModalHeader title={title} onClose={onClose} className={'overflow-hidden'} titleClassName={'truncate'} />
      <div className='space-y-3 p-5 max-w-175 w-screen'>
        <Paragraph>{translate('customDomain.viewDNSRecords.line1')}</Paragraph>

        <VerifyDnsSection
          expectedRecordsCount={expectedDNSRecordsCount}
          domain={domain}
          dnsRecords={dnsRecordsReq.data}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          dnsVerificationStatusMap={dnsVerificationStatusMap}
          setDnsVerificationStatusMap={setDnsVerificationStatusMap}
          buttonColor={'primary'}
          onFailure={onFailure}
        />
      </div>
    </ModalWrapper>
  );
};
